import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, mergeProps as _mergeProps, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createBlock as _createBlock, createElementVNode as _createElementVNode, withModifiers as _withModifiers, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
  key: 0
};
const _hoisted_2 = {
  key: 1
};
const _hoisted_3 = {
  key: 2
};
const _hoisted_4 = {
  key: 0,
  class: "d-flex justify-end"
};
const _hoisted_5 = {
  class: "space-x-2"
};
const _hoisted_6 = ["id"];
const _hoisted_7 = {
  class: "flex justify-start w-2/5 space-x-2"
};
const _hoisted_8 = ["onClick"];
const _hoisted_9 = {
  key: 0,
  class: "d-flex items-center justify-end"
};
const _hoisted_10 = {
  key: 1,
  class: "flex justify-end space-x-2"
};
const _hoisted_11 = {
  class: "space-x-2"
};
const _hoisted_12 = {
  class: "border-8 border-white w-full"
};
const _hoisted_13 = {
  width: "10%",
  class: "text-right"
};
const _hoisted_14 = {
  class: "block",
  "data-cy": "draft-total"
};
import { useInvoiceEditorStore } from '@/modules/billing/invoice/services/useInvoiceEditorStore.js';
import LlSecondaryButton from '@/components/LlSecondaryButton.vue';
import LlTextField from '@/components/LlTextField.vue';
import LlConfirmationDialog from '@/components/LlConfirmationDialog.vue';
import { useInvoiceState } from '@/modules/billing/review/editDraft/useInvoiceState';
import { formatCurrency } from '@/services/utils';
import GroupTable from './GroupTable.vue';
import { storeToRefs } from 'pinia';
import { useMeStore } from '@/services/UserService/useMeStore';
import { useCompanyStore } from '@/services/UserService/useCompanyStore';
import { reactive, ref, computed, nextTick } from 'vue';
import AssignToFixedFeesModal from '@/modules/billing/review/editDraft/modals/AssignToFixedFeeModal.vue';
import { pluralize } from '@/services/utils';
import FixedFeeLineItem from '@/modules/billing/review/editDraft/modals/FixedFeeLineItem.vue';
import { useGroupActions } from './useGroupActions';
import { useInvoiceGroups } from '@/modules/billing/review/editDraft/composables/useInvoiceGroups';
export default {
  __name: 'InvoiceContent',
  props: {
    hideDetail: {
      type: Boolean,
      default: false
    },
    tracking: {
      type: Object,
      required: false
    }
  },
  setup(__props) {
    const props = __props;
    const {
      onlyViewInvoice
    } = storeToRefs(useInvoiceEditorStore());
    const {
      companySettings
    } = storeToRefs(useCompanyStore());
    const meStore = useMeStore();
    const invoiceState = useInvoiceState();
    const invoiceEditorStore = useInvoiceEditorStore();
    const {
      groups,
      totals
    } = invoiceState;
    const saveLaterConfirm = ref(null);
    const makebilledConfirm = ref(null);
    const highlightedGroup = ref(null);
    const {
      getIsLocked
    } = useInvoiceState();
    const {
      makeMultipleLineItemsNonBillable,
      makeMultipleLineItemsBillable,
      makeMultipleLineItemsBilled,
      writeDownMultipleLineItemsToZero,
      assignLineItemsToFixedFee,
      saveMultipleLineItemsForLater
    } = useGroupActions();
    const {
      toggleGroup,
      hasCredit,
      hasItemSelected,
      showAddAndUpdateMenus,
      isEntryGroup,
      selectGroupType,
      sectionOrder,
      updateMenuItems,
      extractSectionType,
      roundedTime
    } = useInvoiceGroups();
    const shouldHideDetails = computed(() => {
      return props.hideDetail === true;
    });
    const actionMappings = {
      fixedFees: {
        label: 'New Fixed Fee',
        action: group => addNewFixedFee(group),
        visible: group => group.type === 'fixedFees'
      },
      expenses: {
        label: 'New Expense',
        action: group => addNewExpense(group),
        visible: group => group.type === 'expenses'
      }
    };
    const invoiceContentState = reactive({
      selectedGroup: null,
      selectedIndex: null,
      showConfirmationDialog: false,
      showFixedFeeAssignModal: false,
      checkedLineItems: [],
      confirmationDialogContent: ''
    });
    const confirmationDialogContent = computed(() => {
      const selectedGroup = invoiceContentState.selectedIndex !== null ? invoiceState.groups[invoiceContentState.selectedIndex] : invoiceContentState.selectedGroup;
      return `Are you sure you want to remove this section containing ${pluralize(selectedGroup?.lineItems, 'line item')} The entries will be saved for later.`;
    });
    const confirmAction = () => {
      invoiceContentState.confirmationDialogContent = confirmationDialogContent;
      saveLaterConfirm.value.open().then(result => {
        if (result && invoiceContentState.selectedIndex !== null) {
          doRemove(invoiceContentState.selectedIndex);
        }
        invoiceContentState.selectedIndex = null;
        invoiceContentState.selectedGroup = null;
        invoiceContentState.showConfirmationDialog = false;
      });
    };
    const handleMenuClick = (action, group) => {
      const checkedLineItems = group.lineItems.filter(li => li.checked);
      invoiceContentState.checkedLineItems = checkedLineItems;
      let objectType = selectGroupType(group);
      invoiceState.eventsToTrack.push({
        category: `${objectType}`,
        action: `line item updated on draft invoice (${action})`,
        properties: {
          count: checkedLineItems.length,
          bulk: checkedLineItems.length > 1
        }
      });
      switch (action) {
        case 'makeNonBillable':
          makeMultipleLineItemsNonBillable(checkedLineItems);
          break;
        case 'writeDownToZero':
          writeDownMultipleLineItemsToZero(checkedLineItems);
          break;
        case 'saveForLater':
          saveMultipleLineItemsForLater(checkedLineItems, group.type);
          break;
        case 'changeMatter':
          checkedLineItems.forEach(lineItem => {
            invoiceEditorStore.editLineItem(lineItem, true, checkedLineItems.length > 1);
          });
          break;
        case 'makeBillable':
          makeMultipleLineItemsBillable(checkedLineItems);
          break;
        case 'markedAsBilled':
          showModelOnMultipleLineItemsBilled(checkedLineItems);
          break;
        case 'assignToFixedFee':
          invoiceContentState.showFixedFeeAssignModal = true;
          break;
        default:
          break;
      }
    };

    // Modify hasMapping to check the actionMappings based on the dynamic type
    const hasMapping = group => {
      let mapping = !!actionMappings[group.type];
      return mapping;
    };
    const doRemove = idx => {
      if (idx === null || idx < 0 || idx >= invoiceState.groups.length) return;
      const groupToRemove = invoiceState.groups[idx];
      const toSave = [...groupToRemove.lineItems];
      const sectionName = groupToRemove.name;
      const sectionType = groupToRemove.type;
      let relatedSection = null;
      let relatedIndex = -1;
      let relatedName = '';
      if (sectionType === 'fixedFees' || sectionName === 'Fixed Fee') {
        relatedName = 'Fixed Fee Detail';
        relatedIndex = invoiceState.groups.findIndex(g => g.name === relatedName && g.matter?.id === groupToRemove.matter?.id);
      } else if (sectionType === 'fixedFeeEntries' || sectionName === 'Fixed Fee Detail') {
        relatedName = 'Fixed Fee';
        relatedIndex = invoiceState.groups.findIndex(g => g.name === relatedName && g.matter?.id === groupToRemove.matter?.id);
      }

      // Only preserve related section for Fixed Fee Detail → Fixed Fee direction
      // When removing Fixed Fee, we want to cascade and also remove the Fixed Fee Detail
      const shouldPreserveRelated = sectionType === 'fixedFeeEntries' || sectionName === 'Fixed Fee Detail';
      if (relatedIndex !== -1 && shouldPreserveRelated) {
        relatedSection = JSON.parse(JSON.stringify(invoiceState.groups[relatedIndex]));
      }

      // Add the removed section back to missingGroups so it can be re-added immediately
      const missingGroupEntry = {
        name: groupToRemove.name,
        type: groupToRemove.type,
        matter: groupToRemove.matter,
        lineItems: []
      };

      // Check if this section type + matter combination already exists in missingGroups
      const existingMissingGroup = invoiceState.missingGroups.find(g => g.type === groupToRemove.type && g.matter?.id === groupToRemove.matter?.id && g.name === groupToRemove.name);
      if (!existingMissingGroup) {
        invoiceState.missingGroups.push(missingGroupEntry);
      }

      // When removing Fixed Fee section, capture related Fixed Fee Detail info
      // BEFORE the cascade (saveMultipleLineItemsForLater may auto-remove the empty group)
      let relatedGroupSnapshot = null;
      if ((sectionType === 'fixedFees' || sectionName === 'Fixed Fee') && relatedIndex !== -1) {
        const relatedGroup = invoiceState.groups[relatedIndex];
        relatedGroupSnapshot = {
          name: relatedGroup.name,
          type: relatedGroup.type,
          matter: relatedGroup.matter,
          lineItems: [...relatedGroup.lineItems]
        };

        // Add Fixed Fee Detail to missingGroups now, before cascade removes it
        const existingMissingRelated = invoiceState.missingGroups.find(g => g.type === relatedGroup.type && g.matter?.id === relatedGroup.matter?.id && g.name === relatedGroup.name);
        if (!existingMissingRelated) {
          invoiceState.missingGroups.push({
            name: relatedGroup.name,
            type: relatedGroup.type,
            matter: relatedGroup.matter,
            lineItems: []
          });
        }
      }

      // Remove the specific index requested
      invoiceState.groups.splice(idx, 1);

      // Now save the items for later (cascade will auto-remove matching detail entries)
      saveMultipleLineItemsForLater(toSave, sectionType);

      // If the cascade didn't fully clean up the related group, remove remaining items
      if (relatedGroupSnapshot) {
        const updatedRelatedIndex = invoiceState.groups.findIndex(g => g.name === relatedGroupSnapshot.name && g.matter?.id === groupToRemove.matter?.id);
        if (updatedRelatedIndex !== -1) {
          const remainingGroup = invoiceState.groups[updatedRelatedIndex];
          const remainingItems = [...remainingGroup.lineItems];
          invoiceState.groups.splice(updatedRelatedIndex, 1);
          if (remainingItems.length > 0) {
            saveMultipleLineItemsForLater(remainingItems, remainingGroup.type);
          }
        }
      }

      // Check if related section was inadvertently removed, restore if needed
      // (only for Fixed Fee Detail → Fixed Fee direction)
      if (relatedSection) {
        const sectionStillExists = invoiceState.groups.some(g => g.name === relatedName && g.matter?.id === groupToRemove.matter?.id);
        if (!sectionStillExists) {
          const insertIdx = relatedIndex > idx ? relatedIndex - 1 : relatedIndex;
          invoiceState.groups.splice(insertIdx, 0, relatedSection);
        }
      }
      invoiceState.credit = !!invoiceState.groups.find(g => g.credit);
      invoiceState.updateLineItemsTotals();
    };
    const removeGroup = (idx, dontPrompt) => {
      if (dontPrompt) {
        return doRemove(idx);
      } else {
        invoiceContentState.selectedIndex = idx;
        confirmAction();
      }
    };
    const saveSectionForLater = idx => {
      invoiceContentState.selectedIndex = idx;
      confirmAction();
    };
    const createNewGroup = async newGroup => {
      let missingGroup = invoiceState.missingGroups.find(g => g.name === newGroup.name && g.matter?.id === newGroup.matter?.id && g.type === newGroup.type);
      if (!missingGroup) return;
      let index = invoiceState.missingGroups.indexOf(missingGroup);
      if (index !== -1) {
        invoiceState.missingGroups.splice(index, 1);
      }

      // Special case for empty invoice - directly add the group
      if (invoiceState.groups.length === 0) {
        invoiceState.groups.push({
          ...newGroup
        });
        await nextTick();
        highlightedGroup.value = newGroup.name;
        setTimeout(() => {
          highlightedGroup.value = null;
        }, 3000);
        return;
      }
      let matterGroups = {};
      invoiceState.groups.forEach(group => {
        let matterId = group.matter?.id || '';
        if (!matterGroups[matterId]) {
          matterGroups[matterId] = [];
        }
        matterGroups[matterId].push(group);
      });
      let newMatterId = newGroup.matter?.id || '';

      // Ensure matterGroup is initialized even if this matter isn't in the groups yet
      if (!matterGroups[newMatterId]) {
        matterGroups[newMatterId] = [];
      }
      let matterGroup = matterGroups[newMatterId];
      let insertIndex = matterGroup.findIndex(group => sectionOrder.indexOf(extractSectionType(group.name)) > sectionOrder.indexOf(extractSectionType(newGroup.name)));
      matterGroup.splice(insertIndex === -1 ? matterGroup.length : insertIndex, 0, newGroup);

      // Rebuild the groups array to preserve correct order
      await nextTick();
      invoiceState.groups = Object.values(matterGroups).flat().sort((a, b) => {
        if (a.matter?.id === b.matter?.id) {
          return sectionOrder.indexOf(extractSectionType(a.name)) - sectionOrder.indexOf(extractSectionType(b.name));
        }
        return 0;
      });
      await nextTick();
      const newIndex = invoiceState.groups.findIndex(g => g.name === newGroup.name && g.matter?.id === newMatterId);
      scrollToElement(`group-${newIndex}`);
      highlightedGroup.value = newGroup.name;
      setTimeout(() => {
        highlightedGroup.value = null;
      }, 3000);
    };
    const scrollToElement = id => {
      const el = document.getElementById(id);
      if (el) {
        el.scrollIntoView({
          behavior: "smooth"
        });
      }
    };
    const createNewEntry = group => {
      let defaultHourValue = companySettings.value.timeEntryIncrement || 0.1;
      let startTime = roundedTime(new Date(), defaultHourValue);
      let matter = group.matter;
      let account = meStore.me;
      let billing = matter?.billing?.type === 'hours' || matter?.billing?.type === 'fixed' ? matter.billing : {
        type: 'none'
      };
      let billingTypeId = billing.type === 'hours' ? 'billable' : billing.type === 'fixed' ? 'fixedFee' : 'nonBillable';
      let rate = billing.type === 'fixed' ? {
        label: 'Fixed Fee',
        amount: 0
      } : {
        label: 'Standard',
        amount: account.rates?.standard || 0
      };
      let billingType = {
        id: billingTypeId
      };
      let newEntry = {
        id: null,
        account: {
          id: account.id,
          name: account.name
        },
        clientId: invoiceState.clientId,
        matterId: matter.id,
        date: new Date(),
        amount: 0,
        hours: defaultHourValue || 0.1,
        billedHours: 0,
        billingType: billingType,
        description: '',
        customFlag: false,
        matter: matter,
        rate: rate,
        notes: '',
        source: 'myleanlaw',
        startTime: startTime,
        endTime: new Date(startTime.getTime() + defaultHourValue * 60 * 60 * 1000)
      };
      let newLineItem = {
        id: null,
        description: '',
        date: new Date(),
        account: {},
        amount: '',
        creditNegative: '',
        includeCodes: false,
        showAccountTotals: false,
        includeHours: false,
        descriptionPreview: '',
        writedown: 0,
        hours: 0,
        worked: 0,
        step: 0,
        entries: [newEntry],
        rate: rate.amount
      };
      invoiceState.eventsToTrack.push({
        category: 'New Time Entry',
        action: 'line item added to draft invoice'
      });
      invoiceEditorStore.newTimeEntry(newLineItem, group);
    };
    const addNewFixedFee = group => {
      let matter = group.matter;
      let account = meStore.me;
      let newFixedFee = {
        id: null,
        account: {
          id: account.id,
          name: account.name
        },
        amount: null,
        codes: {
          task: {
            id: null,
            label: null
          },
          activity: {
            id: null,
            label: null
          }
        },
        description: '',
        completed: true,
        billed: true
      };
      let newLineItem = {
        id: null,
        description: '',
        date: new Date(),
        account: {
          id: account.id,
          name: account.name
        },
        amount: 0,
        codes: {
          task: {
            id: null,
            label: null
          }
        },
        creditNegative: '',
        includeCodes: false,
        showAccountTotals: false,
        includeHours: false,
        descriptionPreview: '',
        charges: [newFixedFee],
        matter: matter,
        completed: true
      };
      invoiceState.eventsToTrack.push({
        category: 'New Fixed Fee',
        action: 'line item added to draft invoice'
      });
      invoiceEditorStore.newFixedFee(newLineItem, group);
    };
    const addNewExpense = group => {
      let matter = group.matter;
      let account = meStore.me;
      let newExpense = {
        id: null,
        account: {
          id: account.id,
          name: account.name
        },
        amount: 0,
        billed: true,
        customFlag: false,
        billable: true,
        description: '',
        matterId: matter.id,
        date: new Date(),
        code: {
          id: null
        },
        method: 'DraftInvoice'
      };
      let newLineItem = {
        id: null,
        description: '',
        date: new Date(),
        account: {
          id: account.id,
          name: account.name
        },
        amount: 0,
        codes: {
          task: {
            id: null,
            label: null
          }
        },
        creditNegative: '',
        includeCodes: false,
        showAccountTotals: false,
        includeHours: false,
        descriptionPreview: '',
        expenses: [newExpense],
        matterId: matter.id
      };
      invoiceState.eventsToTrack.push({
        category: 'New Expense',
        action: 'line item added to draft invoice'
      });
      invoiceEditorStore.newExpense(newLineItem, group);
    };
    const handleAssignToFixedFee = ({
      selectedFixedFee,
      checkedLineItems
    }) => {
      assignLineItemsToFixedFee(checkedLineItems, selectedFixedFee);
      invoiceContentState.showFixedFeeAssignModal = false;
    };
    const showModelOnMultipleLineItemsBilled = checkedLineItems => {
      makebilledConfirm.value.open().then(result => {
        if (result) makeMultipleLineItemsBilled(checkedLineItems);
      });
    };
    return (_ctx, _cache) => {
      const _component_v_dialog = _resolveComponent("v-dialog");
      const _component_v_icon = _resolveComponent("v-icon");
      const _component_v_list_item_title = _resolveComponent("v-list-item-title");
      const _component_v_list_item = _resolveComponent("v-list-item");
      const _component_v_list = _resolveComponent("v-list");
      const _component_v_menu = _resolveComponent("v-menu");
      return _unref(groups).length == 0 ? (_openBlock(), _createElementBlock("p", _hoisted_1, "There are no line items in this invoice")) : shouldHideDetails.value && _unref(groups).length != 0 ? (_openBlock(), _createElementBlock("p", _hoisted_2, " The invoice detail cannot be shown here because it was changed in QuickBooks. ")) : (_openBlock(), _createElementBlock("div", _hoisted_3, [_createVNode(_component_v_dialog, {
        modelValue: invoiceContentState.showFixedFeeAssignModal,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => invoiceContentState.showFixedFeeAssignModal = $event),
        width: "600"
      }, {
        default: _withCtx(() => [_createVNode(AssignToFixedFeesModal, {
          onCancel: _cache[0] || (_cache[0] = $event => invoiceContentState.showFixedFeeAssignModal = false),
          onAssign: handleAssignToFixedFee,
          checkedLineItems: invoiceContentState.checkedLineItems
        }, null, 8, ["checkedLineItems"])]),
        _: 1
      }, 8, ["modelValue"]), _createVNode(_component_v_dialog, {
        modelValue: invoiceContentState.showAddNewFixedFeeModal,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => invoiceContentState.showAddNewFixedFeeModal = $event),
        width: "600"
      }, {
        default: _withCtx(() => [_createVNode(FixedFeeLineItem, {
          isNewFixedFee: true,
          tracking: __props.tracking,
          onCancel: _cache[2] || (_cache[2] = $event => invoiceContentState.showAddNewFixedFeeModal = false)
        }, null, 8, ["tracking"])]),
        _: 1
      }, 8, ["modelValue"]), _createVNode(LlConfirmationDialog, {
        ref_key: "saveLaterConfirm",
        ref: saveLaterConfirm,
        title: "Save Section for Later",
        "confirm-text": "Save for Later",
        "toggle-text": "Keep Section",
        message: invoiceContentState.confirmationDialogContent
      }, null, 8, ["message"]), _createVNode(LlConfirmationDialog, {
        ref_key: "makebilledConfirm",
        ref: makebilledConfirm,
        title: "Mark Time Entries as Billed?",
        "confirm-text": "Mark as Billed",
        "toggle-text": "Cancel",
        message: "Time entries will be permanently removed from the billing workflow but not deleted. They will not appear on any invoices. This action cannot be undone."
      }, null, 512), _unref(invoiceState).missingGroups.length > 0 && !(_unref(getIsLocked) || _unref(onlyViewInvoice)) ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createVNode(_component_v_menu, null, {
        activator: _withCtx(({
          props
        }) => [_createVNode(LlSecondaryButton, _mergeProps({
          variant: "flat",
          class: "!bg-[rgb(var(--v-theme-surface))]",
          "data-cy": "add-section"
        }, props), {
          default: _withCtx(() => [_createVNode(_component_v_icon, {
            class: "no-print"
          }, {
            default: _withCtx(() => [...(_cache[4] || (_cache[4] = [_createTextVNode("mdi-plus", -1)]))]),
            _: 1
          }), _cache[5] || (_cache[5] = _createTextVNode(" Add Section ", -1))]),
          _: 1
        }, 16)]),
        default: _withCtx(() => [_createVNode(_component_v_list, null, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(invoiceState).missingGroups, group => {
            return _openBlock(), _createBlock(_component_v_list_item, null, {
              default: _withCtx(() => [_createVNode(_component_v_list_item_title, {
                onClick: $event => createNewGroup(group)
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(group.name), 1)]),
                _: 2
              }, 1032, ["onClick"])]),
              _: 2
            }, 1024);
          }), 256))]),
          _: 1
        })]),
        _: 1
      })])])) : _createCommentVNode("", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(invoiceState).groups, (group, idx) => {
        return _openBlock(), _createElementBlock("div", {
          key: idx,
          "data-cy": "section-table"
        }, [_createElementVNode("div", {
          class: _normalizeClass(["flex justify-between w-full groups-wrapper mt-2 p-2", {
            highlight: highlightedGroup.value === group.name
          }]),
          "data-cy": "section-header",
          id: `group-${idx}`
        }, [_createElementVNode("div", _hoisted_7, [_createElementVNode("span", {
          class: "pt-2",
          onClick: $event => _unref(toggleGroup)(group)
        }, [_createVNode(_component_v_icon, {
          class: "no-print"
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(group.hide ? 'mdi-chevron-right' : 'mdi-chevron-down'), 1)]),
          _: 2
        }, 1024)], 8, _hoisted_8), _createVNode(LlTextField, {
          "incoming-class": 'gray-background',
          "incoming-name": 'groupName',
          placeholder: "",
          modelValue: group.name,
          "onUpdate:modelValue": $event => group.name = $event,
          disabled: _unref(getIsLocked) || _unref(onlyViewInvoice),
          "data-cy": "section-name"
        }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])]), group.hide ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_unref(formatCurrency)(group.subtotal)), 1)) : (_openBlock(), _createElementBlock("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_unref(showAddAndUpdateMenus)(group) && !(_unref(onlyViewInvoice) || group.hide || _unref(getIsLocked)) ? (_openBlock(), _createBlock(_component_v_menu, {
          key: 0
        }, {
          activator: _withCtx(({
            props
          }) => [_createVNode(LlSecondaryButton, _mergeProps({
            variant: "flat",
            class: "!bg-[rgb(var(--v-theme-surface))]"
          }, {
            ref_for: true
          }, props, {
            "data-cy": "add-section"
          }), {
            default: _withCtx(() => [_createVNode(_component_v_icon, {
              class: "no-print",
              "data-cy": "add"
            }, {
              default: _withCtx(() => [...(_cache[6] || (_cache[6] = [_createTextVNode("mdi-plus", -1)]))]),
              _: 1
            }), _cache[7] || (_cache[7] = _createTextVNode(" Add ", -1))]),
            _: 1
          }, 16)]),
          default: _withCtx(() => [_createVNode(_component_v_list, null, {
            default: _withCtx(() => [_createVNode(_component_v_list_item, null, {
              default: _withCtx(() => [_createVNode(_component_v_list_item, null, {
                default: _withCtx(() => [!(!_unref(isEntryGroup)(group) || _unref(onlyViewInvoice) || _unref(getIsLocked) || _unref(invoiceState).getIsLocked || _unref(hasCredit)(group)) ? (_openBlock(), _createBlock(_component_v_list_item_title, {
                  key: 0,
                  onClick: $event => createNewEntry(group)
                }, {
                  default: _withCtx(() => [_createVNode(_component_v_icon, null, {
                    default: _withCtx(() => [...(_cache[8] || (_cache[8] = [_createTextVNode("mdi-clock-time-nine-outline", -1)]))]),
                    _: 1
                  }), _cache[9] || (_cache[9] = _createTextVNode(" New Time Entry", -1))]),
                  _: 1
                }, 8, ["onClick"])) : _createCommentVNode("", true), hasMapping(group) && actionMappings[group.type].visible(group) ? (_openBlock(), _createBlock(_component_v_list_item_title, {
                  key: 1,
                  class: "hover:cursor-pointer",
                  onClick: $event => actionMappings[group.type].action(group)
                }, {
                  default: _withCtx(() => [_createTextVNode(_toDisplayString(actionMappings[group.type].label), 1)]),
                  _: 2
                }, 1032, ["onClick"])) : _createCommentVNode("", true)]),
                _: 2
              }, 1024)]),
              _: 2
            }, 1024)]),
            _: 2
          }, 1024)]),
          _: 2
        }, 1024)) : _createCommentVNode("", true), _unref(showAddAndUpdateMenus)(group) && !(_unref(onlyViewInvoice) || _unref(getIsLocked)) ? (_openBlock(), _createBlock(_component_v_menu, {
          key: 1
        }, {
          activator: _withCtx(({
            props
          }) => [_createVNode(LlSecondaryButton, _mergeProps({
            variant: "flat",
            class: "!bg-[rgb(var(--v-theme-surface))]"
          }, {
            ref_for: true
          }, props, {
            "data-cy": "update-section"
          }), {
            default: _withCtx(() => [_cache[11] || (_cache[11] = _createTextVNode(" Update ", -1)), _createVNode(_component_v_icon, {
              class: "no-print",
              "data-cy": "update"
            }, {
              default: _withCtx(() => [...(_cache[10] || (_cache[10] = [_createTextVNode("mdi-chevron-down", -1)]))]),
              _: 1
            })]),
            _: 1
          }, 16)]),
          default: _withCtx(() => [_createVNode(_component_v_list, {
            "data-cy": "update-list"
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(updateMenuItems), (item, index) => {
              return _withDirectives((_openBlock(), _createBlock(_component_v_list_item, {
                key: index,
                disabled: item.disabled || !_unref(hasItemSelected)(group) || !item.appliesTo(group)
              }, {
                default: _withCtx(() => [_createVNode(_component_v_list_item_title, {
                  class: "hover:cursor-pointer",
                  onClick: _withModifiers($event => handleMenuClick(item.action, group), ["prevent"])
                }, {
                  default: _withCtx(() => [_createTextVNode(_toDisplayString(item.title), 1)]),
                  _: 2
                }, 1032, ["onClick"])]),
                _: 2
              }, 1032, ["disabled"])), [[_vShow, item.visible !== false]]);
            }), 128))]),
            _: 2
          }, 1024)]),
          _: 2
        }, 1024)) : _createCommentVNode("", true)]), _withDirectives(_createVNode(LlSecondaryButton, {
          onBtnClick: $event => removeGroup(idx, true),
          class: "no-print",
          "data-cy": "remove-section"
        }, {
          default: _withCtx(() => [...(_cache[12] || (_cache[12] = [_createTextVNode(" Remove section ", -1)]))]),
          _: 1
        }, 8, ["onBtnClick"]), [[_vShow, !(_unref(onlyViewInvoice) || _unref(invoiceState).getIsLocked || group.hide || !(group.lineItems.length == 0 || _unref(hasCredit)(group)))]]), _withDirectives(_createVNode(LlSecondaryButton, {
          variant: "flat",
          onBtnClick: $event => saveSectionForLater(idx),
          class: "!bg-[rgb(var(--v-theme-surface))]",
          "data-cy": "save-for-later"
        }, {
          default: _withCtx(() => [...(_cache[13] || (_cache[13] = [_createTextVNode(" Save section for later ", -1)]))]),
          _: 1
        }, 8, ["onBtnClick"]), [[_vShow, !(_unref(onlyViewInvoice) || _unref(invoiceState).getIsLocked || group.hide || group.lineItems.length == 0 || _unref(hasCredit)(group))]])]))], 10, _hoisted_6), _createVNode(GroupTable, {
          group: group
        }, null, 8, ["group"]), _withDirectives(_createElementVNode("span", null, " This section contains no entries or expenses ", 512), [[_vShow, group.lineItems.length == 0]])]);
      }), 128)), _createElementVNode("table", _hoisted_12, [_createElementVNode("tbody", null, [_createElementVNode("tr", null, [_cache[14] || (_cache[14] = _createElementVNode("td", {
        width: "2%"
      }, null, -1)), _cache[15] || (_cache[15] = _createElementVNode("td", {
        width: "12%"
      }, [_createElementVNode("label", {
        class: "block"
      }, "Invoice Total")], -1)), _cache[16] || (_cache[16] = _createElementVNode("td", {
        width: "74%"
      }, null, -1)), _createElementVNode("td", _hoisted_13, [_createElementVNode("label", _hoisted_14, _toDisplayString(_unref(formatCurrency)(_unref(totals).amount)), 1)]), _cache[17] || (_cache[17] = _createElementVNode("td", {
        width: "2%"
      }, " ", -1))])])])]));
    };
  }
};